var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testDiv"},[_c('h1',[_vm._v("Test Page")]),_c('vue-tel-input',{ref:"telInput",attrs:{"autoFormat":false,"inputOptions":_vm.inputOptions,"dropdownOptions":_vm.dropdownOptions}}),_c('button',{on:{"click":_vm.check}},[_vm._v("check")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }